import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=0ca29f00&scoped=true"
import script from "./Start.vue?vue&type=script&lang=ts"
export * from "./Start.vue?vue&type=script&lang=ts"
import style0 from "./Start.vue?vue&type=style&index=0&id=0ca29f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca29f00",
  null
  
)

export default component.exports